import { render, staticRenderFns } from "./CompanyCulture.vue?vue&type=template&id=53db8a80&scoped=true&"
import script from "./CompanyCulture.vue?vue&type=script&lang=js&"
export * from "./CompanyCulture.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCulture.vue?vue&type=style&index=0&id=53db8a80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53db8a80",
  null
  
)

export default component.exports